export const styles = theme => ({
    subtitle: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(3),
        display: 'block'
    },
});